// extracted by mini-css-extract-plugin
export default {"container":"jC-z","brandName":"kC-z","productName":"lC-z","aboveGalleryInfo":"mC-z","belowGalleryInfo":"nC-z","breakLongProductName":"oC-z"};